import { createAsyncThunk } from '@reduxjs/toolkit'
import { _ } from '../../utils/localization'
import { addModal } from '../modals/modalSlice'
import ChatOverview from './ChatOverview'
import { clearCurrentChatId } from './chatSlice'
import openChat from './openChat'

const openChatModal = (eventSlug: string, userId?: number) => createAsyncThunk(
    'OPEN_CHAT_MODAL',
    (__, thunkAPI) => {
        if (userId) {
            thunkAPI.dispatch(openChat(eventSlug, userId))
        }
        thunkAPI.dispatch(addModal({
            Component: ChatOverview,
            header: _('messages.modal_header'),
            size: 'xl',
            callback: () => thunkAPI.dispatch(clearCurrentChatId()),
            padding: 0,
        }))
    },
)()

export default openChatModal
